import { useState, type FormEvent } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "主题分区", href: "#topics" },
  { label: "合集索引", href: "#collections" },
  { label: "最新归档", href: "#archive" },
  { label: "热门榜", href: "#rank" },
  { label: "讨论区", href: "#discussion" },
];

export default function SiteNavbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [hint, setHint] = useState("");

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) {
      setHint("先输入想找的主题或合集名称");
      return;
    }
    setHint(`已按「${value}」为你定位到合集索引`);
    window.setTimeout(() => setHint(""), 2600);
    const target = document.getElementById("collections");
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            黑
          </span>
          <h1 className="font-heading text-xl font-bold leading-none text-foreground-950">
            黑料<span className="text-primary-600">bu</span>
          </h1>
        </a>

        <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3 lg:ml-0">
          <form onSubmit={handleSearch} className="relative hidden items-center md:flex">
            <i className="ri-search-line pointer-events-none absolute left-3 w-4 h-4 flex items-center justify-center text-base text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="text"
              placeholder="搜索主题 / 合集"
              aria-label="搜索主题或合集"
              className="h-10 w-40 rounded-md border border-background-300 bg-background-100 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none xl:w-52"
            />
            {hint && (
              <span className="absolute left-0 top-12 z-10 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-1.5 font-label text-xs text-background-100">
                {hint}
              </span>
            )}
          </form>

          <a
            href="#collections"
            className="hidden shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-download-2-line w-4 h-4 flex items-center justify-center"></i>
            合集入口
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} w-5 h-5 flex items-center justify-center text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <form onSubmit={handleSearch} className="relative mb-3 flex items-center md:hidden">
            <i className="ri-search-line pointer-events-none absolute left-3 w-4 h-4 flex items-center justify-center text-base text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="text"
              placeholder="搜索主题 / 合集"
              aria-label="搜索主题或合集"
              className="h-11 w-full rounded-md border border-background-300 bg-background-100 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
            />
          </form>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}